import { axiosInstance } from '../Middleware';
export class VacancesApi {
  public static couleursZones = ['#2196f3', '#f44336', '#AD1EFA'];
  public static listeVacances = async(codePostal: string, annee: number) => {
    return axiosInstance.get(`/personnel/personnel/vacances?codePostal=${codePostal}&annee=${annee}`)
      .then(response => response.data);
  };
}